import { Menu } from "@headlessui/react";

export const TableMenu = ({ children }) => (
  <Menu as="div" className="relative inline-block text-left">
    {children}
  </Menu>
);
